import React from 'react';
import {
  QueryClient,
  QueryClientProvider as BaseQueryClientProvider,
  QueryClientProviderProps as BaseQueryClientProviderProps,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 3600000,
      staleTime: 3600000,
      refetchOnWindowFocus: false,
    },
  },
});

export type QueryClientProviderProps = Partial<BaseQueryClientProviderProps> & {
  disableDevTools?: boolean;
};

export const QueryClientProvider = ({
  children,
  disableDevTools,
  ...props
}: QueryClientProviderProps) => (
  <BaseQueryClientProvider client={queryClient} {...props}>
    {children}
    {!disableDevTools && <ReactQueryDevtools client={queryClient} />}
  </BaseQueryClientProvider>
);
